<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="login-page">
    <div class="login-card">
      <div class="brand">
        <div class="brand-icon">📦</div>
        <div class="brand-text">库存管家</div>
        <div class="brand-sub">本地经营管理系统</div>
      </div>

      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        @keydown.enter="onSubmit"
        @submit.prevent
        class="login-form"
      >
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入访问密码"
            show-password
            size="large"
            :disabled="loading"
            clearable
          >
            <template #prefix>
              <el-icon><Lock /></el-icon>
            </template>
          </el-input>
        </el-form-item>

        <el-button
          type="primary"
          size="large"
          :loading="loading"
          :disabled="loading"
          class="login-btn"
          @click="onSubmit"
        >
          {{ loading ? '登录中...' : '登 录' }}
        </el-button>
      </el-form>

      <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>

      <div class="footer-hint">
        💡 忘记密码？修改服务器 <code>backend/.env</code> 里的 <code>LOGIN_PASSWORD</code> 后重启
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable vue/multi-word-component-names */
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { Lock } from '@element-plus/icons-vue';
import API_BASE from '@/api';
import { setToken, setUser, isLoggedIn } from '@/utils/auth';

const router = useRouter();
const formRef = ref(null);
const loading = ref(false);
const errorMsg = ref('');

const form = reactive({
  password: ''
});

const rules = {
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ]
};

async function onSubmit() {
  if (loading.value) return;
  errorMsg.value = '';
  try {
    await formRef.value?.validate();
  } catch (e) {
    return; // 校验失败不提交
  }

  loading.value = true;
  try {
    const res = await axios.post(
      `${API_BASE}/api/auth/login`,
      { password: form.password },
      { timeout: 15000, headers: { 'Content-Type': 'application/json' } }
    );
    if (res.data && res.data.success && res.data.token) {
      setToken(res.data.token);
      setUser(res.data.user || 'admin');
      ElMessage.success('登录成功');
      // 跳到来源页或首页
      const redirect = (router.currentRoute.value.query.redirect && String(router.currentRoute.value.query.redirect)) || '/';
      router.replace(redirect);
    } else {
      errorMsg.value = (res.data && res.data.message) || '登录失败';
    }
  } catch (e) {
    const msg = (e.response && e.response.data && e.response.data.message) || e.message || '网络错误';
    errorMsg.value = '登录失败：' + msg;
  } finally {
    loading.value = false;
  }
}

// 如果已经登录，直接进首页
if (isLoggedIn()) {
  router.replace('/');
}
</script>

<style scoped>
.login-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  z-index: 9999;
}
.login-card {
  width: 380px;
  padding: 40px 36px 28px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
}
.brand {
  text-align: center;
  margin-bottom: 28px;
}
.brand-icon {
  font-size: 56px;
  line-height: 1;
}
.brand-text {
  font-size: 22px;
  font-weight: 700;
  color: #303133;
  margin-top: 10px;
}
.brand-sub {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}
.login-form {
  margin-top: 8px;
}
.login-btn {
  width: 100%;
  margin-top: 4px;
  font-size: 15px;
  letter-spacing: 2px;
}
.error-msg {
  margin-top: 14px;
  padding: 8px 12px;
  background: #fef0f0;
  color: #f56c6c;
  font-size: 13px;
  border-radius: 4px;
  text-align: center;
}
.footer-hint {
  margin-top: 22px;
  text-align: center;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
.footer-hint code {
  background: #f5f7fa;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 11px;
  color: #606266;
}
</style>
